<template>
  <div>
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/TaskList"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div style="display: flex" class="task-set-con">
      <div :class="isShow ? 'left' : ['left', 'is-left']" v-if="!isreopen">
        <div class="d-flex" v-show="isShow">
          <el-input
            placeholder="Select existing template"
            v-model="searchKeyWord"
            @input="changeSearchKeyWord"
          >
          </el-input>
          <div class="left-con">
            <div style="margin-top: 20px">
              <el-table
                :data="currentTableData"
                style="width: 100%"
                :row-class-name="tableRowClassName"
                :cell-style="{
                  'text-align': 'center',
                  'padding-right': '10px',
                  cursor: 'pointer',
                }"
                @row-click="templete"
                :row-style="selectedRowStyle"
              >
                <el-table-column prop="taskName" width="180"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="arrow-con">
          <div class="arrow" @click="isShow = !isShow">
            <el-icon v-show="isShow" class="el-icon-arrow-left"></el-icon>
            <el-icon v-show="!isShow" class="el-icon-arrow-right"></el-icon>
          </div>
        </div>
      </div>
      <div class="content_title">
        <div style="margin-top: 20px; margin-bottom: 5px; color: #606266">
          <label>Task Base Information Set</label>
        </div>
        <el-divider></el-divider>
        <div>
          <label style="color: #606266; font-size: 14px"
            >Task Name <label style="color: red">*</label></label
          >
          <el-input
            class="input-search"
            v-model="TaskName"
            placeholder="Please input Task Name"
            :disabled="isreopen"
            maxlength="100"
          ></el-input>
        </div>
        <div>
          <label style="color: #606266; font-size: 14px"
            >Task Start-End Date <label style="color: red">*</label></label
          >
          <el-date-picker
            v-model="date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="To"
            start-placeholder="Start Date"
            end-placeholder="End Date"
            :picker-options="pickerOptions"
            style="margin-top: 10px; margin-left: 20px"
          >
          </el-date-picker>
          <el-button
            class="button-search"
            style="margin-left: 10px; display: inline"
            @click="Extend"
            v-if="isadmin && isreopen"
            >Extend</el-button
          >
        </div>
        <el-divider></el-divider>
        <div>
          <label style="color: #606266; font-size: 14px"
            >Filter Condition Set</label
          >
          <el-button type="mini" @click="addFilter" :disabled="isreopen"
            >Add Filter Condition</el-button
          >
          <div style="margin-top: 10px" v-if="!isreopen">
            <div
              v-for="(filterdiv, index) in divs"
              :key="index"
              :div_id="filterdiv.id"
            >
              <el-select
                filterable
                v-model="filterdiv.filtermenu"
                clearable
                placeholder="Please Choose"
                style="margin-left: 10px; width: 150px"
                @change="GetFilterData(index, filterdiv.filtermenu)"
              >
                <el-option
                  v-for="item in filters"
                  :key="item.field_Name"
                  :label="item.column_Name"
                  :value="item.field_Name"
                ></el-option>
              </el-select>
              <el-select
                v-model="filterdiv.filterwhere1"
                clearable
                placeholder="Please Choose"
                style="margin-left: 10px; width: 150px"
                v-if="filterdiv.istype != 2"
              >
                <el-option
                  v-for="item in iss"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-select
                v-model="filterdiv.filterwhere2"
                clearable
                placeholder="Please Choose"
                style="margin-left: 10px; width: 150px"
                v-if="filterdiv.istype == 2"
              >
                <el-option
                  v-for="item in isss"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                class="input-filter"
                v-model="filterdiv.filtervalue"
                placeholder="value1,value2,value3..."
                maxlength="200"
                style="width: 500px; margin-left: 10px"
                @change="Replace1(filterdiv.id, filterdiv.filtervalue)"
                v-if="filterdiv.istype != 1"
              ></el-input>
              <el-select
                filterable
                v-model="filterdiv.filtervalues"
                clearable
                multiple
                placeholder="Please Choose"
                style="margin-left: 10px; width: 500px; margin-top: 10px"
                v-if="filterdiv.istype == 1"
              >
                <el-option
                  v-for="item in filterdiv.filteroptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-button @click="delFilter(filterdiv.id)">X</el-button>
            </div>
          </div>
          <div style="margin-top: 10px" v-if="isreopen">
            <div
              v-for="(filterdiv, index) in showdivs"
              :key="index"
              :div_id="filterdiv.id"
            >
              <el-input
                v-model="filterdiv.filtermenu"
                style="margin-left: 10px; width: 150px"
                disabled="disabled"
              ></el-input>
              <el-input
                v-model="filterdiv.filterwhere"
                style="margin-left: 10px; width: 150px"
                disabled="disabled"
              ></el-input>
              <el-input
                class="input-filter"
                v-model="filterdiv.filtervalue"
                style="width: 700px; margin-left: 10px"
                disabled="disabled"
              ></el-input>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div>
          <div style="height: 50px">
            <label>Primary Key <label style="color: red">*</label></label>
            <el-radio-group
              v-model="PrimaryKey"
              :disabled="!TaskStatus"
              style="margin-left: 10px"
            >
              <el-radio
                v-for="item in keys"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              ></el-radio>
            </el-radio-group>
          </div>
          <div style="display: flex">
            <div style="width: 240px; height: 300px; padding-left: 40px">
              <div style="height: 50px">
                <label>Columns <label style="color: red">*</label></label>
              </div>
              <div style="height: 50px">
                <el-button
                  @click="posclick"
                  style="width: 100px"
                  :disabled="!TaskStatus"
                  >POS</el-button
                >
              </div>
              <div style="height: 50px">
                <el-button
                  @click="proclick"
                  style="width: 100px"
                  :disabled="!TaskStatus"
                  >Project</el-button
                >
              </div>
              <div style="height: 50px">
                <el-button
                  @click="pipeclick"
                  style="width: 100px"
                  :disabled="!TaskStatus"
                  >Pipeline</el-button
                >
              </div>
              <div style="height: 50px"></div>
            </div>
            <div>
              <el-transfer
                filterable
                :filter-method="filterMethod"
                filter-placeholder="Please input character"
                v-model="transfervalue"
                :titles="['Available', 'Selected']"
                :data="datas"
                ref="myTransfer"
              ></el-transfer>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div>
          <div>
            <label style="color: #606266; font-size: 14px"
              >Custom Column Set</label
            >
            <el-button type="mini" @click="addColumn"
              >Add Column Condition</el-button
            >
            <div style="margin-top: 10px">
              <div style="display: flex">
                <label style="width: 166px">Column Name</label>
                <label style="width: 166px">Parent Column</label>
                <label style="width: 163px">Category</label>
                <label style="width: 166px">Required</label>
                <label style="width: 160px">Content</label>
              </div>
              <div
                v-for="(column, index) in columns"
                :key="index"
                :div_id="column.id"
                style="display: flex"
              >
                <el-input
                  class="input-filter"
                  v-model="column.columnname"
                  placeholder="Please input"
                  maxlength="100"
                  style="width: 150px"
                  @change="columnnamecheck(column.id, column.columnname)"
                  :disabled="!TaskStatus"
                ></el-input>
                <el-select
                  v-model="column.parentcolumn"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px; width: 150px; margin-top: 10px"
                  @click.native="getParents(column.id)"
                  @change="parentChange(column.id)"
                >
                  <!-- :disabled="!TaskStatus ? !TaskStatus : column.disabled" -->
                  <el-option
                    v-for="item in parents"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="column.columncate"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px; width: 150px; margin-top: 10px"
                  @change="disclick(column.id, column.columncate)"
                  :disabled="!TaskStatus"
                >
                  <el-option
                    v-for="item in cates"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="column.columnrequired"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px; width: 150px; margin-top: 10px"
                  :disabled="!TaskStatus"
                >
                  <el-option
                    v-for="item in column.isrequired"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
                <el-input
                  v-if="!column.isparent"
                  class="input-filter"
                  v-model="column.columncontent"
                  placeholder="content1,content2,content3..."
                  maxlength="200"
                  type="textarea"
                  rows="1"
                  style="width: 360px; margin-left: 10px"
                  :disabled="!TaskStatus ? !TaskStatus : column.disabled"
                  @change="Replace2(column.id, column.columncontent)"
                ></el-input>
                <div v-if="column.isparent">
                  <div v-if="column.columncontents.length > 0">
                    <div
                      v-for="(cct, index) in column.columncontents"
                      :key="index"
                      class="input-filter"
                      style="width: 360px; margin-left: 10px"
                    >
                      <label
                        >{{
                          cct.parentlabel +
                          (isEmpty(cct.parentlabel) ? "" : "-")
                        }}{{ cct.label }}</label
                      >
                      <el-select
                        v-model="cct.columnrequired"
                        clearable
                        placeholder="Required"
                        style="
                          margin-left: 10px;
                          width: 150px;
                          margin-top: 10px;
                        "
                        v-if="column.columnrequired == 'Custom'"
                        :disabled="!TaskStatus"
                      >
                        <el-option
                          v-for="item in isparentrequired"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <el-input
                        maxlength="200"
                        style="margin-top: 5px"
                        v-model="cct.input"
                        type="textarea"
                        rows="1"
                        @change="
                          Replace3(
                            column.id,
                            cct.parentlabel,
                            cct.label,
                            cct.input
                          )
                        "
                        :disabled="column.disabled"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <el-button
                  @click="delColumn(column.id)"
                  style="
                    margin-left: 5px;
                    margin-top: 10px;
                    width: 50px;
                    height: 40px;
                  "
                  :disabled="!TaskStatus"
                  >X</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <el-checkbox v-model="isTemplate" v-if="!isreopen && isadmin"
          >Add Template</el-checkbox
        >
        <el-button
          class="button-search"
          v-if="!isreopen && isadmin"
          @click="create"
          :disabled="iscreateclisk"
          >Start Task</el-button
        >
        <el-button
          class="button-search"
          v-if="isreopen && isadmin"
          @click="reopen"
          :disabled="isreopenclisk"
          >ReOpen</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTemplate: false,
      searchKeyWord: "",
      page: "",
      tableData: [],
      currentTableData: [],
      test: "",
      TaskName: "",
      date: [],
      filters: [],
      newfilters: [],
      iss: ["in", "not in"],
      isss: [">=", "<="],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 91);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 182);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      divs: [
        {
          id: 0,
          filtermenu: "",
          filterwhere1: "",
          filterwhere2: "",
          filtervalue: "",
          istype: 0,
          filtervalues: [],
          filteroptions: [],
        },
      ],
      showdivs: [],
      columns: [
        {
          id: 0,
          columnname: "",
          parentcolumn: "",
          columncate: "",
          isrequired: ["Required", "Optional", "Not fillable"],
          columnrequired: "",
          columncontent: "",
          columncontents: [],
          disabled: false,
          isparent: false,
        },
      ],
      cates: ["Text", "Dropdown List", "Date", "Integer", "0.00"],
      isparentrequired: ["Required", "Optional", "Not fillable"],
      div_num: 0,
      PrimaryKey: "",
      keys: [],
      datas: [],
      transfervalue: [],
      filterMethod(query, item) {
        return item.pinyin.indexOf(query.toLowerCase()) > -1;
      },
      parents: [],
      isreopen: false,
      isadmin: false,
      TaskStatus: true,
      reopendisabled: false,
      taskset: {},
      iscreateclisk: false,
      isreopenclisk: false,
      isShow: true,
      getRowIndex: null,
    };
  },
  methods: {
    changeSearchKeyWord(c) {
      this.currentTableData = this.tableData.filter((v) => {
        return v.taskName.toLowerCase().indexOf(c.toLowerCase()) != -1;
      });
    },
    selectedRowStyle({ row, rowIndex }) {
      if (this.getRowIndex === row.id) {
        return { "font-weight": "bold" };
      }
    },
    templete(row, column) {
      var id = row.id;
      this.getRowIndex = id;
      var oo = this.tableData.find((p) => p.id == id);
      this.tableData.forEach((p) => (p.font = ""));
      oo.font = " fontweight";
      this.TaskName = oo.taskName;
      var tfs = JSON.parse(oo.taskFilters);
      this.divs = [];
      tfs.forEach((p) => {
        var o = {
          id: 1,
          filtermenu: "",
          filterwhere1: "",
          filterwhere2: "",
          filtervalue: "",
          istype: 0,
          filtervalues: [],
          filteroptions: [],
        };
        var istype = this.filters.find(
          (t) => t.field_Name == p.filtermenu
        ).istype;
        o.id = p.id;
        o.filtermenu = p.filtermenu;
        o.istype = istype;
        this.$api
          .get("/Task/GetPrimaryName", { ID: oo.primaryKey }, (res) => {})
          .then((res) => {
            if (res.data.status) {
              this.PrimaryKey = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          });

        if (istype == 1) {
          o.filterwhere1 = p.filterwhere1;
          o.filtervalues = p.filtervalue.split(",");
          this.$api
            .get(
              "/Task/GetFilterValues",
              { fieldname: p.filtermenu },
              (res) => {}
            )
            .then((res) => {
              if (res.data.status) {
                o.filteroptions = res.data.content;
              } else {
                this.$message({
                  type: "error",
                  message: res.data.message,
                });
                return false;
              }
            });
        } else if (istype == 2) {
          o.filterwhere2 = p.filterwhere2;
          o.filtervalue = p.filtervalue;
        } else if (istype == 0) {
          o.filterwhere1 = p.filterwhere1;
          o.filtervalue = p.filtervalue;
        }
        this.divs.push(o);
      });
      var taskIDs = oo.taskIDs.split(",");
      this.transfervalue = [];
      taskIDs.forEach((element) => {
        this.transfervalue.push(Number(element));
      });
      this.$api
        .get("/Task/GetTemplateCustomColumn/", { TaskID: id }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.columns = res.data.content;
            this.columns.forEach((element) => {
              this.isEmpty(element.parentcolumn)
                ? (element.isrequired = [
                    "Required",
                    "Optional",
                    "Not fillable",
                  ])
                : (element.isrequired = [
                    "Required",
                    "Optional",
                    "Custom",
                    "Not fillable",
                  ]);
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetTaskConfig() {
      this.$api
        .get(
          "/Task/GetTaskConfig/",
          { pageIndex: 1, page: 10, flag: 0, dates: "" },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetTaskConfigTemplate() {
      this.$api
        .get(
          "/Task/GetTaskConfigTemplate/",
          { pageIndex: 1, page: 10, dates: "" },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.content;
            this.currentTableData = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    create() {
      this.iscreateclisk = true;
      if (this.isEmpty(this.TaskName)) {
        this.iscreateclisk = false;
        this.$message({
          type: "error",
          message: "Task Name is empty",
        });
        return;
      }
      if (this.date == null || this.date.length == 0) {
        this.iscreateclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Start-End Time",
        });
        return;
      }
      if (this.isEmpty(this.PrimaryKey)) {
        this.iscreateclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Primary key",
        });
        return;
      }
      var pk = this.keys.find((p) => p.label == this.PrimaryKey);
      if (this.transfervalue.find((p) => p == pk.key) == null) {
        this.iscreateclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Primary key  in Columns",
        });
        return;
      }
      if (this.transfervalue == null || this.transfervalue.length == 0) {
        this.iscreateclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Columns",
        });
        return;
      }
      var values = this.transfervalue.join(",");
      var arr = [];
      this.date.forEach((p) => arr.push(this.formateDate(p)));
      var dates = arr.join(",");
      var pk = this.keys.find((p) => p.label == this.PrimaryKey);

      this.$api
        .put("/Task/CreateTaskConfig/", {
          TaskName: this.TaskName,
          PrimaryKey: pk.key,
          Dates: dates,
          Filters: JSON.stringify(this.divs),
          Columns: values,
          CustomColumns: JSON.stringify(this.columns),
          TaskStatus: true,
          IsTemplate: this.isTemplate,
        })
        .then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "Create Success",
            });
            this.$router.push({ path: "/TaskList" });
          } else {
            this.iscreateclisk = false;
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          }
        });
    },
    reopen() {
      this.isreopenclisk = true;
      if (this.date == null || this.date.length == 0) {
        this.isreopenclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Start-End Time",
        });
        return;
      }
      if (this.isEmpty(this.PrimaryKey)) {
        this.isreopenclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Primary key",
        });
        return;
      }
      var pk = this.keys.find((p) => p.label == this.PrimaryKey);
      if (this.transfervalue.find((p) => p == pk.key) == null) {
        this.isreopenclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Primary key  in Columns",
        });
        return;
      }
      if (this.transfervalue == null || this.transfervalue.length == 0) {
        this.isreopenclisk = false;
        this.$message({
          type: "error",
          message: "Please choose  Columns",
        });
        return;
      }

      var values = this.transfervalue.join(",");
      var arr = [];
      this.date.forEach((p) => arr.push(this.formateDate(p)));
      var dates = arr.join(",");
      var pk = this.keys.find((p) => p.label == this.PrimaryKey);

      this.$api
        .put("/Task/UpdateTaskConfig/", {
          Dates: dates,
          Columns: values,
          CustomColumns: JSON.stringify(this.columns),
          TaskStatus: true,
          PrimaryKey: pk.key,
          ID: this.page,
        })
        .then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "ReOpen Success",
            });
            this.$router.push({ path: "/TaskList" });
          } else {
            this.isreopenclisk = false;
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          }
        });
    },
    isEmpty(obj) {
      if (typeof obj == "undefined" || obj == null || obj == "") {
        return true;
      } else {
        return false;
      }
    },
    formateDate(datetime) {
      if (!(datetime == "" || datetime == null || datetime == undefined)) {
        function addDateZero(num) {
          return num < 10 ? "0" + num : num;
        }
        let d = new Date(datetime);
        let formatdatetime =
          d.getFullYear() +
          "-" +
          addDateZero(d.getMonth() + 1) +
          "-" +
          addDateZero(d.getDate());
        return formatdatetime;
      }
    },
    GetTaskColumn() {
      this.$api
        .get("/Task/GetTaskColumn/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            var datas = res.data.content;
            datas.forEach((element) => {
              if (
                element.column_Name == "POS Code" ||
                element.column_Name == "Project Code"
              ) {
                this.keys.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
                this.datas.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
              } else {
                this.datas.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
              }
            });
            console.log(this.keys);
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    GetFixedColumn() {
      this.$api
        .get("/Task/GetFixedColumn/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.filters = res.data.content;
            this.newfilters = this.filters;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    addFilter() {
      var maxid = this.Max(this.divs.map((a) => a.id));
      var oo = {
        id: maxid + 1,
        filtermenu: "",
        filterwhere1: "",
        filterwhere2: "",
        filtervalue: "",
        istype: 0,
        filtervalues: [],
        filteroptions: [],
      };
      this.divs.push(oo);
    },
    delFilter(filterid) {
      var oo = this.divs.find((p) => p.id == filterid);
      var index = this.divs.indexOf(oo);
      this.divs.splice(index, 1);
    },
    addColumn() {
      var maxid = this.Max(this.columns.map((a) => a.id));
      var oo = {
        id: maxid + 1,
        columnname: "",
        parentcolumn: "",
        columncate: "",
        isrequired: ["Required", "Optional", "Not fillable"],
        columnrequired: "",
        columncontent: "",
        columncontents: [],
      };
      this.columns.push(oo);
    },
    delColumn(columnid) {
      var oo = this.columns.find((p) => p.id == columnid);
      var index = this.columns.indexOf(oo);
      this.columns.splice(index, 1);
    },
    disclick(ID, value) {
      var oo = this.columns.find((p) => p.id == ID);
      if (oo.columncate == "Dropdown List") {
        oo.disabled = false;
      } else {
        oo.disabled = true;
        oo.columncontent = "";
        oo.columncontents.forEach((element) => {
          element.input = "";
        });
      }
      // if (value != "Dropdown List") {
      //   oo.disabled = true;
      //   oo.parentcolumn = "";
      //   oo.columncontent = "";
      //   oo.columncontents = [];
      //   oo.isparent = false;
      // } else {
      //   oo.disabled = false;
      // }
    },
    posclick() {
      this.$refs.myTransfer.$children["0"]._data.query = "pos:";
    },
    proclick() {
      this.$refs.myTransfer.$children["0"]._data.query = "project:";
    },
    pipeclick() {
      this.$refs.myTransfer.$children["0"]._data.query = "pipeline:";
    },
    getParents(id) {
      this.parents = [];
      this.columns.forEach((p) => {
        if (
          !this.isEmpty(p.columnname) &&
          p.id != id &&
          p.columncate == "Dropdown List"
        ) {
          this.parents.push(p.columnname);
        }
      });
    },
    parentChange(id) {
      var oo = this.columns.find((p) => p.id == id);
      if (!this.isEmpty(oo.parentcolumn)) {
        oo.isrequired = ["Required", "Optional", "Custom", "Not fillable"];
        oo.isparent = true;
        var cct = this.columns.find((p) => p.columnname == oo.parentcolumn);
        if (this.isEmpty(cct.parentcolumn)) {
          var arr = [];
          if (!this.isEmpty(cct.columncontent)) {
            cct.columncontent.split(",").forEach((element) => {
              arr.push({ key: "", value: element });
            });
          }
        } else {
          var arr = [];
          if (cct.columncontents.length > 0) {
            cct.columncontents.forEach((element) => {
              element.input.split(",").forEach((ele) => {
                arr.push({ key: element.label, value: ele });
              });
            });
          }
        }
        if (arr.length > 0) {
          var temp = [];
          for (var j = 0; j < arr.length; j++) {
            // if (!this.isEmpty(arr[j].value)) {
            temp.push({
              column: cct.columnname,
              parentlabel: arr[j].key,
              label: arr[j].value,
              input: "",
            });
            // }
          }
          oo.columncontents = temp;
        } else {
          oo.columncontents = [];
        }
      } else {
        oo.isrequired = ["Required", "Optional", "Not fillable"];
        oo.isparent = false;
      }
    },
    Replace1(id, content) {
      content = content.replace(/，/g, ",");
      content = content.replace(/；/g, ",");
      content = content.replace(/;/g, ",");
      var oo = this.divs.find((p) => p.id == id);
      oo.filtervalue = this.trimSpace(
        this.distinct(content.split(","))
      ).toString();
    },
    Replace2(id, content) {
      content = content.replace(/，/g, ",");
      content = content.replace(/；/g, ",");
      content = content.replace(/;/g, ",");
      var oo = this.columns.find((p) => p.id == id);
      oo.columncontent = this.trimSpace(
        this.distinct(content.split(","))
      ).toString();
      var arr = oo.columncontent.split(",");
      if (!this.isEmpty(oo.columnname)) {
        for (var i = 0; i < this.columns.length; i++) {
          if (this.columns[i].parentcolumn == oo.columnname) {
            if (this.columns[i].columncontents.length == 0) {
              for (j = 0; j < arr.length; j++) {
                this.columns[i].columncontents.push({
                  column: oo.columnname,
                  parentlabel: "",
                  label: arr[j],
                  input: "",
                });
              }
            } else {
              for (var j = 0; j < arr.length; j++) {
                var temp = this.columns[i].columncontents.find(
                  (p) => p.label == arr[j]
                );
                if (temp == null) {
                  this.columns[i].columncontents.push({
                    column: oo.columnname,
                    parentlabel: "",
                    label: arr[j],
                    input: "",
                  });
                }
              }
              var n = this.columns[i].columncontents.length - 1;
              for (var m = n; m >= 0; m--) {
                var temp = arr.find(
                  (p) => p == this.columns[i].columncontents[m].label
                );
                if (temp == null) {
                  this.columns[i].columncontents.splice(m, 1);
                }
              }
            }
          }
        }
      }
    },
    Replace3(id, parentlabel, label, input) {
      input = input.replace(/，/g, ",");
      input = input.replace(/；/g, ",");
      input = input.replace(/;/g, ",");
      var oo = this.columns.find((p) => p.id == id);
      var ctt = oo.columncontents.find(
        (p) => p.parentlabel == parentlabel && p.label == label
      );
      ctt.input = this.trimSpace(this.distinct(input.split(","))).toString();
      var arr = ctt.input.split(",");
      var temp = [];
      var ctts = [];
      arr.forEach((element) => {
        temp.push({
          column: oo.columnname,
          parentlabel: ctt.label,
          columnrequired: "",
          label: element,
          input: "",
        });
      });
      if (!this.isEmpty(oo.columnname)) {
        if (oo.columncontents.length > 0) {
          for (var i = 0; i < this.columns.length; i++) {
            if (this.columns[i].parentcolumn == oo.columnname) {
              var columncontents = temp;
              if (this.columns[i].columncontents != null) {
                columncontents.forEach((element) => {
                  var tt = this.columns[i].columncontents.find(
                    (p) =>
                      p.parentlabel == element.parentlabel &&
                      p.label == element.label
                  );
                  if (tt != null) {
                    element.input = tt.input;
                  }
                });
              }
              for (
                var j = this.columns[i].columncontents.length - 1;
                j >= 0;
                j--
              ) {
                if (
                  this.columns[i].columncontents[j].parentlabel == ctt.label
                ) {
                  this.columns[i].columncontents.splice(j, 1);
                }
              }
              if (this.columns[i].columncontents.length > 0) {
                ctts = this.columns[i].columncontents;
              }
              ctts = ctts.concat(columncontents);
              this.columns[i].columncontents = ctts;
            }
          }
        }
      }
    },
    trimSpace(array) {
      for (var i = 0; i < array.length; i++) {
        if (
          array[i] == "" ||
          array[i] == null ||
          typeof array[i] == "undefined"
        ) {
          array.splice(i, 1);
          i = i - 1;
        }
      }
      return array;
    },
    columnnamecheck(id, columnname) {
      if (!this.isEmpty(columnname)) {
        for (var i = 0; i < this.columns.length; i++) {
          if (
            id != this.columns[i].id &&
            columnname == this.columns[i].columnname
          ) {
            var oo = this.columns.find((p) => p.id == id);
            oo.columnname = "";
            alert("Column Name  are not allowed to be repeated");
          }
        }
      }
    },
    isEmpty(str) {
      if (str == "" || str == null || str == undefined) {
        return true;
      } else {
        return false;
      }
    },
    distinct(arr) {
      var nArr = [];
      for (var i = 0; i < arr.length; i++) {
        if (nArr.indexOf(arr[i]) == -1) {
          nArr.push(arr[i]);
        }
      }
      return nArr;
    },
    Max(arr) {
      if (arr.length > 0) {
        var MaxNumber = arr[0];
        for (var i = 0; i < arr.length; i++) {
          if (MaxNumber < arr[i]) {
            MaxNumber = arr[i];
          }
        }
        return MaxNumber;
      } else {
        return 0;
      }
    },
    fielterquery(value) {
      this.newfilters = this.filters.filter(
        (item) => item.field_Name.toLowerCase() === value.toLowerCase()
      );
    },
    reopenInit() {
      this.$api
        .get("/Task/GetTaskColumn/", {}, (res) => {})
        .then((res) => {
          if (res.data.status) {
            var datas = res.data.content;
            datas.forEach((element) => {
              if (
                element.column_Name == "POS Code" ||
                element.column_Name == "Project Code"
              ) {
                this.keys.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
                this.datas.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
              } else {
                this.datas.push({
                  key: element.id,
                  label: element.column_Name,
                  pinyin: (
                    element.tag +
                    ":" +
                    element.column_Name
                  ).toLowerCase(),
                });
              }
            });

            this.$api
              .get("/Task/GetOneTaskSet/", { ID: this.page }, (res) => {})
              .then((res) => {
                if (res.data.status) {
                  var pk = this.keys.find(
                    (p) => p.key == res.data.content.primaryKey
                  );
                  this.TaskName = res.data.content.taskName;
                  this.PrimaryKey = pk.label;
                  this.showdivs = JSON.parse(res.data.content.taskFilters);
                  var taskIDs = res.data.content.taskIDs.split(",");
                  this.transfervalue = [];
                  taskIDs.forEach((element) => {
                    this.transfervalue.push(Number(element));
                  });
                  this.TaskStatus = res.data.content.taskStatus;
                  this.date.push(res.data.content.taskStartTime);
                  this.date.push(res.data.content.taskEndTime);

                  if (this.TaskStatus == false) {
                    this.datas.forEach((element) => {
                      element.disabled = true;
                    });
                  }
                } else {
                  this.$message({
                    type: "error",
                    message: res.data.message,
                  });
                  return false;
                }
              });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
      this.$api
        .get("/Task/GetCustomColumn/", { TaskID: this.page }, (res) => {})
        .then((res) => {
          if (res.data.status) {
            this.columns = res.data.content;
            this.columns.forEach((element) => {
              this.isEmpty(element.parentcolumn)
                ? (element.isrequired = [
                    "Required",
                    "Optional",
                    "Not fillable",
                  ])
                : (element.isrequired = [
                    "Required",
                    "Optional",
                    "Custom",
                    "Not fillable",
                  ]);
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
      this.$api
        .get("/Login/IsAdminOrAs/", {}, (res) => {})
        .then((res) => {
          this.isreopen = res.data;
        });
    },
    Extend() {
      var arr = [];
      this.date.forEach((p) => arr.push(this.formateDate(p)));
      var dates = arr.join(",");
      this.$api
        .post("/Task/Extend/", {
          ID: this.page,
          Dates: dates,
        })
        .then((res) => {
          if (res.data.status) {
            this.$message({
              type: "success",
              message: "Extend Success",
            });
          } else {
            this.iscreateclisk = false;
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
            }
          }
        });
    },
    GetFilterData(index, filtermenu) {
      var oo1 = this.divs[index];
      oo1.filtervalue = "";
      oo1.filtervalues = [];
      var oo2 = this.filters.find((p) => p.field_Name == filtermenu);
      oo1.istype = oo2.istype;
      console.log(this.divs);
      this.$api
        .get(
          "/Task/GetFilterValues",
          { fieldname: oo2.field_Name },
          (res) => {}
        )
        .then((res) => {
          if (res.data.status) {
            oo1.filteroptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
            return false;
          }
        });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      }
      return "";
    },
  },
  mounted() {
    this.$api
      .get("/Login/IsAdmin/", {}, (res) => {})
      .then((res) => {
        this.isadmin = res.data;
      });
    this.$nextTick(() => {
      this.page = this.$route.params.ID;
      if (this.isEmpty(this.page)) {
        this.GetTaskColumn();
        this.GetFixedColumn();
        this.GetTaskConfigTemplate();
      } else {
        this.reopenInit();
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.template1 {
  background-color: #ffffff;
}
.template2 {
  background-color: #dddddd;
}
.fontweight {
  font-weight: bold;
}
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.left {
  text-align: left;
  width: 200px;
  height: 600px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  &.is-left {
    width: 12px;
  }
  .d-flex {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 20px;
  }

  .left-con {
    flex: 1;
    overflow: auto;
  }
}
.arrow-con {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 600px;
  display: flex;
  align-items: center;
  .arrow {
    border-radius: 0 38px 38px 0;
    width: 12px;
    height: 76px;
    text-align: center;
    font-size: 12px;
    line-height: 76px;
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
  }
}

.content_title {
  margin: auto;
  width: 1050px;
  margin-top: 10px;
  text-align: left;

  .input-search {
    margin-top: 10px;
    margin-left: 20px;
    margin-right: 10px;
    width: 300px;
  }
  .input-filter {
    margin-top: 10px;
    width: 300px;
  }
  .button-search {
    background-color: #e6a23c;
    border: 0px #e6a23c;
    color: #ffff;
    margin-top: 10px;
    display: block;
    margin-bottom: 20px;
  }
}
</style>
<style>
.task-set-con .el-transfer-panel {
  text-align: left !important;
  width: 280px !important;
}
.task-set-con .el-checkbox {
  padding-left: 10px !important;
  text-align: left !important;
}
.el-table .warning-row {
  background: #a0cfff;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskSet.vue